import { BellOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const alerts: string[] = [
    'Nutrifuel share at Target dipped to 16.8% vs 20.4% year ago',
    'Market leader Haven Mills has declined from 49.6% to 46.9% in share',
    'Consumption of value packs in chocolate going down for own & category',
];

export default function JumpBackInCard() {
    const navigate = useNavigate();

    return (
        <div className="h-full">
            <div className="p-6 h-full flex flex-col">
                {/* Header */}
                <div className="flex items-center justify-between mb-4">
                    <div className="flex items-center gap-2">
                        <BellOutlined style={{ color: '#374151', fontSize: 18 }} />
                        <h2 className="text-lg mb-0 font-semibold text-gray-900">Alerts</h2>
                    </div>

                    {/* View all */}
                    <button
                        type="button"
                        onClick={() => navigate('/all-alerts/view-all')}
                        className="text-sm font-medium text-purpleFont hover:underline transition-colors"
                    >
                        View all
                    </button>
                </div>

                {/* Alert list */}
                <div className="flex-1 flex flex-col justify-center gap-5 pt-2">
                    {alerts.map((text, index) => (
                        <div
                            key={index}
                            className="rounded-lg px-4 py-4 text-sm text-gray-700"
                            style={{ backgroundColor: '#F7F7FA' }}
                        >
                            {text}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export { JumpBackInCard };
